export default {
  path: '/sims/sim-tariffs',
  name: 'SimTariffs',
  component: () => import(/* webpackChunkName: "base" */ '../views/SimTariffsView.vue'),
  meta: {
    exclude: false,
    requiresAuth: true
  }
}
